import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import galleryData from "./data/galleryData";
import About from "./pages/About";
import ScrollToTop from "./components/ScrollToTop";
import Projects from "./pages/Projects";
import ProjectDetails from "./pages/ProjectDetails";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        {/* Top navigation bar */}
        <Navbar />

        {/* Page content */}
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery categories={galleryData} />} />
            <Route path="/about" element={<About />} />
            <Route path="projects" element={<Projects />}/>
            <Route path="projects/:id" element={<ProjectDetails />}/>
          </Routes>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
